// TODO danielmana should this match the EAppointmentStatus?
export var EChecklistAppointmentStatus = /*#__PURE__*/function (EChecklistAppointmentStatus) {
  EChecklistAppointmentStatus["Cancelled"] = "cancelled";
  EChecklistAppointmentStatus["Confirmed"] = "confirmed";
  EChecklistAppointmentStatus["Pending"] = "pending";
  return EChecklistAppointmentStatus;
}({});